import asteroideGray from "./asteroide-gray.svg";
import etoileFilante from "./etoile-filante.svg";
import globeBlue from "./globe-blue.svg";
import globeGreen from "./globe-green.svg";
import globePrinceAssise from "./globe-prince-assise.svg";
import globePrinceStar1 from "./globe-prince-star-1.svg";
import globeYellowSingleBig from "./globe-yellow-single-big.svg";
import globeYellowSingleLittle from "./globe-yellow-single-little.svg";
import globeYellowSingleMedium from "./globe-yellow-single-medium.svg";
import globeYellow from "./globe-yellow.svg";
import logoSushiPetitPrince from "./logo-sushi-petit-prince.svg";
import planetteBeige from "./planette-beige.svg";
import planetteBeigeHalf from "./planette-beige-half.svg";
import planetteYellow1Star1 from "./planette-yellow-1-star-1.svg";
import planetteYellow1 from "./planette-yellow-1.svg";
import planetteYellow2 from "./planette-yellow-2.svg";
import star3Bottom from "./star-3-bottom.svg";
import stars3Middle from "./stars-3-middle.svg";
import stars3Top from "./stars-3-top.svg";
import starsGray from "./stars-gray.png";
import start3V2 from "./start-3-v2.svg";
import starsGroup from "./stars-group.png";
import californiaRose from "./products/california_rose.png";
import makiPrince from "./products/maki_prince.png";
import springRenard from "./products/spring_renard.png";
import sushiEtoile from "./products/sushi_etoile.png";
import cloud from "./cloud.svg";
import starYellowA from "./star-yellow-a.svg";
import starYellowX from "./star-yellow-x.svg";
import yellowMoon from "./yellow-moon.svg";
import orangeMoon from "./orange-moon.svg";
import yellowBigStar from "./yellow-big-star.png";
import fox from "./fox.png";
import standingPrince from "./standing-prince.svg";

export const lePetitPrinceImages = {
  asteroideGray,
  etoileFilante,
  globeBlue,
  globeGreen,
  globePrinceAssise,
  globePrinceStar1,
  globeYellowSingleBig,
  globeYellowSingleLittle,
  globeYellowSingleMedium,
  globeYellow,
  logoSushiPetitPrince,
  planetteBeige,
  planetteBeigeHalf,
  planetteYellow1Star1,
  planetteYellow1,
  planetteYellow2,
  star3Bottom,
  stars3Middle,
  stars3Top,
  starsGray,
  start3V2,
  starsGroup,
  cloud,
  starYellowA,
  starYellowX,
  yellowMoon,
  orangeMoon,
  yellowBigStar,
  fox,
  standingPrince,
  products: {
    californiaRose,
    makiPrince,
    springRenard,
    sushiEtoile,
  },
};
